import { render, staticRenderFns } from "./AsLatestTabsItems.vue?vue&type=template&id=4f5973e0&scoped=true"
import script from "./AsLatestTabsItems.vue?vue&type=script&lang=js"
export * from "./AsLatestTabsItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f5973e0",
  null
  
)

export default component.exports